import { useEffect, useState } from 'react'
import { useDebounce } from '@hooks/useDebounce'

export default function CaptureScreen() {
  const { debounce } = useDebounce()
  const [disableCapture, setDisableCapture] = useState(false)

  function keyDownHandler(e: KeyboardEvent) {
    if (e.key === 'Meta' && !disableCapture) {
      setDisableCapture(true)
    }
  }
  function keyUpHandler(e: KeyboardEvent) {
    if (e.key === 'Meta') {
      debounce(() => {
        setDisableCapture(false)
      }, 1000)
    }
    if (e.key === 'PrintScreen') {
      navigator.clipboard?.writeText('')
    }
  }

  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener('keydown', keyDownHandler)
      window.addEventListener('keyup', keyUpHandler)
    }

    return () => {
      window.removeEventListener('keydown', keyDownHandler)
      window.removeEventListener('keyup', keyUpHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (disableCapture) {
    return (
      <div className='fixed right-0 left-0 top-0 bottom-0 bg-white dark:bg-dark-9 flex justify-center items-center z-50' />
    )
  }
  return null
}
